<template>
	<Teleport to="body">
		<VrpAlertModal
			v-if="visible"
			@rightClick="hideNotification"
			v-bind="{
				title: `${currentMessageParam.title !== undefined ? currentMessageParam.title : ''}`,
				text1: `${currentMessageParam.text1 !== undefined ? currentMessageParam.text1 : ''}`,
				text2: `${currentMessageParam.text2 !== undefined ? currentMessageParam.text2 : ''}`,
				text3: `${currentMessageParam.text3 !== undefined ? currentMessageParam.text3 : ''}`,
				leftBtnEnable: false,
				rightBtnText: '확인',
				titleColor: '#000000',
			}"
		/>
	</Teleport>
</template>

<script setup>
import { ref } from 'vue';
import eventBus from '@vrp/js/eventBus'; // eventBus 가져오기
import { Queue } from '@vrp/js/queue.js';
import VrpAlertModal from '@/vrp/components/modal/common/VrpAlertModal.vue';

const queue = new Queue();
const visible = ref(false);
const currentMessageParam = ref({});
const isShowingMessage = ref(false);

function showNotification(message) {
	if (!isShowingMessage.value) {
		queue.enqueue(message);
		displayNextNotification();
	} else {
		queue.clear();
	}
}

function displayNextNotification() {
	if (!queue.isEmpty()) {
		currentMessageParam.value = queue.dequeue();
		visible.value = true;
		isShowingMessage.value = true;
	}
}

function hideNotification() {
	visible.value = false;
	isShowingMessage.value = false;
	// 메시지를 숨긴 후 큐에서 다음 메시지를 표시
	if (!queue.isEmpty()) {
		displayNextNotification();
	}
}

eventBus.on('notification-popup:show', message => {
	showNotification(message);
});

eventBus.on('notification-popup:hide', () => {
	if (visible.value) {
		hideNotification();
	}
});
</script>

<style scoped>
.notification-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3); /* 반투명 검정색 배경 (30% 불투명도) */
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000; /* 다른 요소 위에 표시되도록 */
}

.notification {
	background-color: #fefefe; /* 흰색 배경 */
	color: #333; /* 검정색 텍스트 */
	padding: 20px;
	border-radius: 5px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	max-width: 300px;
	width: 100%;
}

.notification-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

button {
	background: none;
	border: none;
	color: #007bff; /* 시스템 alert과 유사한 색상 */
	cursor: pointer;
	font-size: 16px;
}
</style>
